import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Injectable()
export class SeoService {
    private readonly _dom: Document;
    private readonly _isBrowser: boolean;
    private _linkCanonical?: HTMLLinkElement;

    constructor(
        private _router: Router,
        @Inject(DOCUMENT) document: Document,
        @Inject(PLATFORM_ID) platformId: string
    ) {
        this._isBrowser = isPlatformBrowser(platformId);
        this._dom = document;

        if (this._isBrowser) {
            this.createCanonicalTag();
        }
    }

    createCanonicalTag() {
        this._linkCanonical = this._dom.createElement('link');
        this._linkCanonical?.setAttribute('rel', 'canonical');
        this._dom.head.appendChild(this._linkCanonical);
        this._linkCanonical?.setAttribute('href', this._getCanonicalUrl());
    }

    trackCanonicalChanges() {
        if (!this._isBrowser) {
            return;
        }

        this._router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                untilDestroyed(this)
            )
            .subscribe(() => {
                this._linkCanonical?.setAttribute('href', this._getCanonicalUrl());
            });
    }

    private _getCanonicalUrl(): string {
        return this._dom.location.origin + this._dom.location.pathname;
    }
}
